
import { IAdjustmentDisplay, ICustomFieldShowData } from '@/store/type'
import KeyenceHTHardKeyButton from '@/components/keyenceHT/hardkeys/KeyenceHTHardKeyButton.vue'
import { Options, Vue } from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'
import { format } from 'date-fns'
import { IActivationCustomField, IProject, ITrackpoint } from '@/utils/types/projectTypes'
import { IBarcode } from '@/utils/types/barcodeTypes'
import { DATE_TIME } from '@/utils/constants'
import { ECustomFieldUnitPosition } from '@/utils/enums'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import { isKeyenceEnterpriseBrowser } from '@/utils/keyenceHT/keyenceModules'

@Options({
  emits: ['update:isShow'],
  name: 'AdjustmentDataDialog',
  components: {
    KeyenceHTHardKeyButton,
  },
})
export default class AdjustmentDataDialog extends Vue {
  KeyenceHardKey = KeyenceHardKey

  get isKeyenceEnterpriseBrowser() {
    return isKeyenceEnterpriseBrowser()
  }

  @PropSync('isShow', { type: Boolean }) _isShow!: boolean
  @Prop({ type: Object }) readonly adjustmentField!: ICustomFieldShowData

  closeDialog() {
    this._isShow = false
  }

  get barcode(): IBarcode {
    return this.$store.state.barcode?.barcode
  }

  get project(): IProject {
    return this.$store.state.project?.details
  }

  get trackPoints(): Record<string, ITrackpoint> {
    return this.project.trackPoints
  }

  get customFieldSetting(): IActivationCustomField {
    return this.project?.barcodeTypes?.[this.barcode.barcodeType]?.activationFields?.customFields?.[
      this.adjustmentField.cfKey
    ]
  }

  get customFieldData() {
    return this.barcode.activationData?.customFields?.[this.adjustmentField.cfKey]
  }

  get tableData(): IAdjustmentDisplay[] {
    const cfKey = this.adjustmentField?.cfKey || ''
    const result = [] as IAdjustmentDisplay[]
    if (this.barcode.trackingData) {
      let startValue = this.customFieldData?.adjustment || 0
      for (const tdData of this.barcode.trackingData) {
        if (tdData.customFields?.[cfKey]) {
          const value = tdData.customFields?.[cfKey]?.adjustment || 0
          const operatorType = value > 0 ? 'increase' : 'decrease'
          const currentNode = this.trackPoints?.[tdData.currentTrackPointKey].name || ''
          const nextNode = this.trackPoints?.[tdData.nextTrackPointKey].name || ''
          const currentValue = startValue + value
          result.push({
            date: format(new Date(tdData.audit?.trackedDateTime as string), DATE_TIME.WITH_SECOND),
            operatorType,
            currentNode,
            nextNode,
            startValue,
            value: Math.abs(value),
            currentValue,
          })
          startValue = currentValue
        }
      }
    }

    return result
  }

  formatValue(value?: number) {
    if (value !== undefined && value !== null) {
      if (this.customFieldSetting?.unitType && this.customFieldSetting?.position) {
        if (this.customFieldSetting.position === ECustomFieldUnitPosition.PREFIX) {
          return `${this.customFieldSetting.unitType} ${value}`
        } else if (this.customFieldSetting.position === ECustomFieldUnitPosition.SUFFIX) {
          return `${value} ${this.customFieldSetting.unitType}`
        }
      }
      return value.toString()
    }
    return ''
  }
}
